<template>
  <div>
    <div
      class="sortby-select-wrapper flex items-center space-x-1.5 text-sm cursor-pointer md:space-x-3 ml-3"
      :class="{ 'bg-base-0 py-2 px-3 shadow-card rounded-md': !simplified }"
      ref="sortby-select-wrapper"
      @click="handleOpenDropdown()"
    >
      <span style="color: #6F7078;" v-if="!simplified">
        {{ $i18nPresenter.t("Sort by") }}
      </span>
      <span class="text-secondary-100">
        <span v-if="sortColumn === 'name'">
          <span v-if="sortOrder === 'asc'">{{ $i18nPresenter.t("Alphabetical") }}</span>
          <span v-else>{{ $i18nPresenter.t("Alphabetical (reversed)") }}</span>
        </span>

        <span v-if="sortColumn === 'updatedAt'">
          <span v-if="sortOrder === 'asc'">{{ $i18nPresenter.t("Oldest (update time)") }}</span>
          <span v-else>{{ $i18nPresenter.t("Recently updated") }}</span>
        </span>

        <span v-if="sortColumn === 'createdAt'">
          <span v-if="sortOrder === 'asc'">{{ $i18nPresenter.t("Oldest (creation time)") }}</span>
          <span v-else>{{ $i18nPresenter.t("Recently created") }}</span>
        </span>

      </span>
      <span class="border-r h-7 border-secondary-20" v-if="!simplified" />
      <span>
        <aha-icon
          name="arrow"
          width="14"
          height="14"
          viewBox="0 0 24 24"
        />
      </span>
    </div>
    <aha-context-menu
      ref="context-menu-sort"
      full-width
      @hide="handleHideDropdown()"
    >
      <h5 class="context-menu-header">
        {{ $i18nPresenter.t("Sort Presentations") }}
      </h5>
      <ul>
        <li
          class="context-menu-item"
          @click="handleSortCriteriaChange('name', 'asc')"
        >
          {{ $i18nPresenter.t("Alphabetical") }}
        </li>
        <li
          class="context-menu-item"
          @click="handleSortCriteriaChange('name', 'desc')"
        >
          {{ $i18nPresenter.t("Alphabetical (reversed)") }}
        </li>
        <li
          class="context-menu-item"
          @click="handleSortCriteriaChange('updatedAt', 'desc')"
        >
          {{ $i18nPresenter.t("Recently updated") }}
        </li>
        <li
          class="context-menu-item"
          @click="handleSortCriteriaChange('createdAt', 'desc')"
        >
          {{ $i18nPresenter.t("Recently created") }}
        </li>
        <li
          class="context-menu-item"
          @click="handleSortCriteriaChange('updatedAt', 'asc')"
        >
          {{ $i18nPresenter.t("Oldest (update time)") }}
        </li>
        <li
          class="context-menu-item"
          @click="handleSortCriteriaChange('createdAt', 'asc')"
        >
          {{ $i18nPresenter.t("Oldest (creation time)") }}
        </li>
      </ul>
    </aha-context-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    simplified: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      sortColumn: (state) => state.selections.selectedSortCriteria.sortColumn,
      sortOrder: (state) => state.selections.selectedSortCriteria.sortOrder,
    }),
  },
  methods: {
    ...mapActions(['setSelectedSortCriteriaAction']),
    handleOpenDropdown() {
      this.$refs['context-menu-sort'].show()
      this.$refs['sortby-select-wrapper'].classList.add('active')
    },
    handleHideDropdown() {
      this.$refs['sortby-select-wrapper'].classList.remove('active')
    },
    handleSortCriteriaChange(sortColumn, sortOrder) {
      this.setSelectedSortCriteriaAction({
        sortOrder,
        sortColumn,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.sortby-select-wrapper {
  @apply border border-transparent transition-colors;
  &:hover {
    @apply md:border-primary-90;
  }
  &.active {
    @apply md:border-primary-100;
  }
}
</style>
